import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CUSTOMER_MAIL_FIX, CustomerMailBlockReason, CustomerMailRefusal } from '../../utils/customerMailGuard';

/**
 * The reason under a disabled "save and send email" (PO, 2026-10-30): which
 * payment prerequisite the mail lacks, and a link to where it is fixed. The
 * save without a mail stays available beside it.
 */
const CustomerMailBlockedNote = ({ refusal }: { refusal: CustomerMailRefusal | null }) => {
    const { t } = useTranslation();
    if (!refusal) return null;
    const fix = CUSTOMER_MAIL_FIX[refusal.reason];
    return (
        <p className={'mt-2 text-xs text-foreground/60'} data-testid={'customer-mail-blocked-note'}>
            {t('customer_mail_guard.not_sendable')}{' '}
            <Link to={fix.to} className={'text-primary underline'}>
                {t(fix.labelKey)}
            </Link>
        </p>
    );
};

/**
 * The reason beside the booking's "Nicht gesendet" badge when the payment rule
 * refused its last mail (`communication.email.blocked`): "– <reason>", the
 * reason being the link to where it is fixed. Distinct from a technical
 * failure, which carries no reason.
 */
export const CustomerMailBlockedReason = ({ reason }: { reason: CustomerMailBlockReason | undefined }) => {
    const { t } = useTranslation();
    if (!reason) return null;
    const fix = CUSTOMER_MAIL_FIX[reason];
    return (
        <span className={'ml-1 text-sm text-foreground/60'} data-testid={'customer-mail-blocked-reason'}>
            {'– '}
            <Link to={fix.to} className={'text-primary underline'}>
                {t(fix.labelKey)}
            </Link>
        </span>
    );
};

export default CustomerMailBlockedNote;
